/** Shared browser-language detection. Czech uses the language code cs, not CZ. */
export function getBrowserLanguage(locale = globalThis.navigator?.language || "en-US") {
    const language = String(locale).trim().toLowerCase().split(/[-_]/)[0];
    return language === "cz" ? "cs" : language || "en";
}
